import './settings'
import { platform, devFxProxy, vuetify } from '@/index.js'

import '@/styles/markdown.css'
import './router'
import request from '@/lib/utils/request'

import { router, store } from '@/myops/core'
import appBase from './App'
import getModules from '@/lib/utils/getModules'
import '@/components/vxe-table/index'
import Vue from 'vue'
import '@/styles/styles.scss'
import Message from './components/message'
import { isMobile } from '@/modules/chat/util'
import '@/bus/event-bus'
// import vuetify from '@/plugins/vuetify'
import './icons'

Vue.prototype.$message = Message

// 引入 Vant 组件
import './plugins/vant'

// import vuetify from './plugins/vuetify'
import { DeviceDetector, TabletDetector } from '@/utils/device-detector.js'

// const deviceInfo = DeviceDetector.getDeviceInfo()
// console.log('设备信息:', deviceInfo)

const tabletDeviceInfo = TabletDetector.getDeviceInfo();

console.log('平板设备检测结果:', tabletDeviceInfo);

Vue.prototype.$isMobile = (isMobile() || tabletDeviceInfo.isTablet) && window.innerWidth < 1024

Vue.prototype.$isTablet = tabletDeviceInfo.isTablet

const modules = getModules()

const app = new platform({
  modules,
})

app.setProxy(new devFxProxy(request))

// new Vue({
//   router,
//   store,
//   vuetify,
//   render: h => h(appBase)
// }).$mount('#app')


app.render({
  app: appBase,
  plugins: {
    vuetify,
  },
})

